module.exports = __webpack_public_path__ + "static/media/nonImage.1b3aafab.png";